<template>
  <section class="flex flex-col gap-8 w-full m-auto">
    <div class="m-auto">
      <IconSparkles class="inline" size="12" />
      <span class="caption text-static-default-low ml-2">
        {{ i18n(translations.promptSuggestionsTitle) }}
      </span>
    </div>
    <RevButtonBase
      v-for="(text, index) in suggestions"
      :key="index"
      class="bg-static-info-low text-static-info-hi p-12 rounded-lg !rounded-br-sm w-full text-start"
      @click="$emit('click', text)"
    >
      <div class="flex justify-between gap-8">
        <div>
          {{ text }}
        </div>
        <IconArrowUpInCircleFilled class="shrink-0" size="24" />
      </div>
    </RevButtonBase>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconArrowUpInCircleFilled } from '@ds/icons/IconArrowUpInCircleFilled'
import { IconSparkles } from '@ds/icons/IconSparkles'

import translations from '../ShoppingAssistant.translations'

defineProps<{ suggestions: string[] }>()

defineEmits(['click'])

const i18n = useI18n()
</script>
